export interface SubmissionIntent { id: string; contents: string }

/** Authority for one form submission, independent of asynchronous UI renders. */
export class SubmissionGate {
  pending: SubmissionIntent | null = null;
  busy = false;
  request(contents: string) {
    if (this.busy || this.pending) return null;
    return this.pending = { id: crypto.randomUUID(), contents };
  }
  cancel() { this.pending = null; }
  consume(id: string, contents: string, token: string) {
    if (!token || this.busy || this.pending?.id !== id || this.pending.contents !== contents) return false;
    this.cancel(); this.busy = true;
    return true;
  }
  finish() { this.busy = false; }
}
